module.exports = __webpack_public_path__ + "img/组 5.a9eb54bf.png";